module.exports = __webpack_public_path__ + "static/icons/icon-unlock--black-523c0f81c46f50b1d861c875c775e924.svg";